module.exports = __webpack_public_path__ + "img/6fea004.png";